exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".fwtRp6LGtMSs5yth3CWI5{width:100%;height:100%}", ""]);
// Exports
exports.locals = {
	"uiLessContainer": "fwtRp6LGtMSs5yth3CWI5"
};